var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data)?_c('div',{on:{"click":_vm.select}},[(_vm.data.ttsessiontype_name)?_c('p',{staticClass:"font-bold mb-2"},[_vm._v(_vm._s(_vm.data.ttsessiontype_name))]):_vm._e(),(_vm.children > 0)?_c('p',{staticClass:"mb-0"},[_c('b-icon',{attrs:{"icon":"check-circle-fill","variant":"success"}}),_vm._v(" Assist ")],1):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }